import React from 'react';

import { EColor } from '../Theme';

export const CheckIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Checked</title>
    <path
      d="M5 13L9 17L19 7"
      stroke={EColor.Black}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
